<nz-tabs nzTabPosition="top" nzSize="small">
  <nz-tab *ngFor="let category of categories; trackBy: trackByCategory"
          [nzTitle]="(category.labelKey | translateTA)">
    <ng-template nz-tab>
      <div class="palette-grid">
        <div class="palette-item"
             *ngFor="let item of category.items; trackBy: trackByItem"
             (click)="onAdd(item.type)"
             [nz-tooltip]="(item.descriptionKey | translateTA)"
             nzTooltipPlacement="right"
             role="option">
          <nz-icon [nzType]="getIcon(item.type)" nzTheme="outline"
                   class="palette-icon"></nz-icon>
          <span class="palette-label">{{ (item.labelKey | translateTA) }}</span>
        </div>
      </div>
    </ng-template>
  </nz-tab>
</nz-tabs>
